import { z } from "zod";

export const interviewCategorySchema = z.enum([
  "behavioral",
  "technical",
  "situational",
  "company-specific",
]);

export const interviewDifficultySchema = z.enum(["easy", "medium", "hard"]);

export const interviewQuestionSchema = z.object({
  question: z.string(),
  category: interviewCategorySchema,
  difficulty: interviewDifficultySchema,
});

export const interviewSessionSchema = z.object({
  id: z.string(),
  jobId: z.string().nullable(),
  questions: z.array(interviewQuestionSchema),
  companyBrief: z.string().nullable(),
  createdAt: z.string(),
});

export const answerFeedbackSchema = z.object({
  score: z.number().min(1).max(10),
  strengths: z.array(z.string()),
  improvements: z.array(z.string()),
  revisedAnswer: z.string(),
});

export const interviewAnswerSchema = z.object({
  id: z.string(),
  sessionId: z.string(),
  questionIndex: z.number(),
  answer: z.string(),
  feedback: answerFeedbackSchema.nullable(),
  createdAt: z.string(),
});

export const questionBankQueryInput = z.object({
  roleType: z.string(),
  seniorityLevel: z.enum(["entry", "mid", "senior", "executive"]),
});

export type InterviewQuestion = z.infer<typeof interviewQuestionSchema>;
export type InterviewSession = z.infer<typeof interviewSessionSchema>;
export type AnswerFeedback = z.infer<typeof answerFeedbackSchema>;
export type InterviewAnswer = z.infer<typeof interviewAnswerSchema>;
export type InterviewCategory = z.infer<typeof interviewCategorySchema>;
export type InterviewDifficulty = z.infer<typeof interviewDifficultySchema>;
export type QuestionBankQuery = z.infer<typeof questionBankQueryInput>;
